import styled from 'styled-components';

import { HOME, SPACE, WEBSITE_ANALYTICS } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const List = styled.ol`
  list-style: none;
  margin: ${SPACE[0]};
  padding: ${SPACE[4]} ${SPACE[4]} ${SPACE[8]};
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

export const Row = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  min-width: 0;
`;

export const Line = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: ${SPACE[12]};
  min-width: 0;
`;

export const Names = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[2]};
  min-width: 0;
`;

export const Name = styled(Text)`
  font-size: 15px;
  font-weight: 500;
  color: ${HOME.t100};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SubName = styled(Text)`
  font-size: 12px;
  color: ${HOME.t500};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** The second line as a link out (the live page, in a new tab), with its small arrow. */
export const SubLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[4]};
  min-width: 0;
  max-width: 100%;
  font-size: 12px;
  color: ${HOME.t500};
  text-decoration: none;

  &:hover {
    color: ${HOME.t300};
    text-decoration: underline;
  }
`;

export const SubLinkText = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Figures = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${SPACE[2]};
  flex-shrink: 0;
`;

/** The value with its change pill before it. */
export const ValueLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
`;

export const Value = styled(Text)`
  font-size: 15px;
  font-weight: 600;
  color: ${HOME.t50};
  white-space: nowrap;
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${HOME.t400};
  white-space: nowrap;
`;

export const Track = styled.div`
  height: 6px;
  border-radius: 999px;
  background: ${WEBSITE_ANALYTICS.barTrack};
  overflow: hidden;
`;

/** A row's share: a neutral bar (the accent colour is kept for the charts and the headline figures). */
export const Fill = styled.div<{ $share: number }>`
  height: 100%;
  width: ${({ $share }) => `${Math.max(2, Math.round($share * 100))}%`};
  border-radius: inherit;
  background: ${HOME.t400};
`;

export const Empty = styled(Text)`
  display: block;
  padding: ${SPACE[16]} ${SPACE[4]};
  font-size: 14px;
  color: ${HOME.t400};
`;
